/* eslint-disable */
import { useState } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

const AddUtilityDialog = ({ open, onClose, onSave }) => {
  const [utilityName, setUtilityName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [unit, setUnit] = useState("");
  const [type, setType] = useState("");
  const [purpose, setPurpose] = useState("");
  const [description, setDescription] = useState("");

  const handleSave = () => {
    if (
      !utilityName.trim() ||
      !quantity.trim() ||
      !unit.trim() ||
      !type.trim() ||
      !purpose.trim() ||
      !description.trim()
    ) {
      alert("Please fill in all fields");
      return;
    }
    const newUtility = {
      id: Date.now().toString(),
      name: utilityName,
      value: {
        quantity: parseFloat(quantity),
        unit,
        type,
        details: {
          purpose,
        },
      },
      description,
    };
    onSave(newUtility);
    setUtilityName("");
    setQuantity("");
    setUnit("");
    setType("");
    setPurpose("");
    setDescription("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Utility</DialogTitle>
      <DialogContent>
        <TextField
          label="Utility Name"
          value={utilityName}
          onChange={(e) => setUtilityName(e.target.value)}
          fullWidth
          margin="normal"
          autoFocus
        />
        <TextField
          label="Quantity"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          fullWidth
          margin="normal"
          type="number"
        />
        <TextField
          label="Unit"
          value={unit}
          onChange={(e) => setUnit(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Type"
          value={type}
          onChange={(e) => setType(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Purpose"
          value={purpose}
          onChange={(e) => setPurpose(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          fullWidth
          margin="normal"
          multiline
          rows={3}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          color="primary"
          disabled={
            !utilityName.trim() ||
            !quantity.trim() ||
            !unit.trim() ||
            !type.trim() ||
            !purpose.trim() ||
            !description.trim()
          }
        >
          Save Utility
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddUtilityDialog;